import { observer } from 'owa-mobx-react';
import React from 'react';
import type { IStackTokens } from '@fluentui/react/lib/Stack';
import { Stack } from '@fluentui/react/lib/Stack';
import { BadgeColor, default as EventListItemBadge } from '../EventListItemBadge';
import {
    emojiIcon,
    titleAndHostContainer,
    titleAndBadgeContainer,
    eventListItemTitle,
    eventListItemDateTime,
    durationAndBadgeContainer,
    eventListItemSummary,
    singleLine,
} from './EventListItem.scss';

import classNames from 'owa-classnames';
import { EmojiIcon } from 'accelerator-common/lib/EmojiPicker';
import { defaultEmojiMeetingType } from '../../utils/emojiConstants';
import getSimpleDurationString from '../../utils/getSimpleDurationString';

export interface EventListItemDateAndTitlesProps {
    title: string;
    badgeText?: string;
    duration: number;
    summary: string;
    emoji?: string;
    hasGreyBackground: boolean;
    hasBadge: boolean;
}

const EventListItemDateAndTitles = observer(function EventListItem(
    props: EventListItemDateAndTitlesProps
) {
    const { title, duration, summary, emoji = defaultEmojiMeetingType } = props;
    const singleLineSummary = false;
    /* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop  -- (https://aka.ms/OWALintWiki)
     * Causes extra re renders of component
     *	> JSX attribute values should not contain objects created in the same scope */
    const stackTokens: IStackTokens = {
        childrenGap: 10,
    };
    /* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop  -- (https://aka.ms/OWALintWiki)
     * Causes extra re renders of component
     *	> JSX attribute values should not contain objects created in the same scope */
    const outerStackTokens: IStackTokens = {
        childrenGap: 5,
    };
    const badgeColor = props.hasGreyBackground ? BadgeColor.Grey : BadgeColor.Primary;
    return (
        <>
            <EmojiIcon className={emojiIcon} emojiKey={emoji || defaultEmojiMeetingType} />
            <Stack className={classNames(titleAndHostContainer)} tokens={outerStackTokens}>
                <Stack
                    className={titleAndBadgeContainer}
                    horizontal={true}
                    verticalAlign="center"
                    tokens={stackTokens}
                >
                    <div title={title} className={classNames(eventListItemTitle)}>
                        {title}
                    </div>
                    <EventListItemBadge color={badgeColor} isDisabled={props.hasBadge} />
                </Stack>
                <div className={classNames(eventListItemDateTime, durationAndBadgeContainer)}>
                    {getSimpleDurationString(duration)}
                </div>
                <div
                    title={summary}
                    className={classNames(eventListItemSummary, {
                        [singleLine]: singleLineSummary,
                    })}
                >
                    {summary}
                </div>
            </Stack>
        </>
    );
},
'EventListItem');

export default EventListItemDateAndTitles;
